import { useState } from "react";
const useCompleteMsgModal = () => {
  const [showMsgModal, setShowMsgModal] = useState<boolean>(false);

  const closeButtonMsg = () => {
    setShowMsgModal(false);
  };

  return {
    showMsgModal,
    setShowMsgModal,
    closeButtonMsg,
  };
};

export default useCompleteMsgModal;
